// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 957 ? "views-app" : chunkId) + "." + {"512":"4882b240","957":"43a699d6"}[chunkId] + ".chunk.css";
};